const OUTGOING_WEBHOOK_STATUS = Object.freeze({
    FAILING: 'failing',
    UNKNOWN: 'unknown',
    WORKING: 'working',
});

module.exports = {
    OUTGOING_WEBHOOK_STATUS,
};
